import React, { FC, useEffect, useState } from "react";
import "./mostAttemptedQuiz.scss";
import PenIcon from "../../../assets/icons/pen.svg";
import { Col, Row, Spin, Typography } from "antd";
import faker from "faker";
import AttemptsIcon from "../../../assets/icons/attempt.svg";
import PlayIcon from "../../../assets/icons/play.svg";
import PdfIcon from "../../../assets/icons/document.svg";
import ThumbUpIcon from "../../../assets/icons/thumb-up.svg";
import ThumbDownIcon from "../../../assets/icons/thumb-down.svg";
import DashboardFilter from "../DashboardFilter";
import DashboardService from "../../../services/DashboardService/dashboard.service";
import { MostAttemptedQuizModel } from "../../../models/DashboardModel/MostAttemptedQuizModel/mostAttemptedQuiz.model";
import { serialize } from "serializr";
import { _DashboardFilterModel } from "../../../models/DashboardModel/DashboardFilterModel/_dashboardFilter.model";
import { defaultFilter } from "../../../shared/utils/filter";

const { Paragraph } = Typography
interface MostAttemptedQuizProps { }

const MostAttemptedQuiz: FC<MostAttemptedQuizProps> = (props:any) => {
  const {user } = props;
  const [loading, setLoading] = useState(false);
  const [quiz, setQuiz] = useState<MostAttemptedQuizModel[]>([]);
  const fetchMostAttemptedQuiz = (params?: any) => {
    setLoading(true)
    const payload = serialize(_DashboardFilterModel, params ?? defaultFilter);
    DashboardService.fetchMostAttemptedQuiz(
      payload,
      (quiz) => {
        setQuiz(quiz);
        setLoading(false);
      },
      () => {
        setLoading(false)
      },
      () => { }
    );
  };

  useEffect(() => {
    if (user?.roleName === 'admin')
    fetchMostAttemptedQuiz();
  }, []);

  return (
    <div className="most-attempted-content">
      <div className="most-attempted-content__header-wrapper">
        <div className="most-attempted-content__header">
          <img src={PenIcon} />
          Most attempted quiz
        </div>
        <DashboardFilter
          applyHandler={(values) => fetchMostAttemptedQuiz({ ...defaultFilter, ...values })}
          clearHandler={() => fetchMostAttemptedQuiz()}
        />
      </div>
      <div className="most-attempted-content__wrapper">
        {loading ? (
          <Spin tip="Loading..." className="spin__loader" />
        ) : !quiz?.length ? (
          <p className="no__data">No data!</p>
        ) : (
          quiz?.map((value, index) => {
            return (
              <Row key={"most_attempted#" + index} className="most-attempted-content__card">
                <Col span={24}>
                  <div className="most-attempted-content__card-right">
                    <Paragraph ellipsis={{ expandable: false, rows: 1 }} className="most-attempted-content__card-title">
                      {value?.contentName}
                    </Paragraph>
                    <p className="most-attempted-content__breadcrumb">
                      {`${value?.board} > ${value?.classRoom} > ${value?.subject} > ${value?.chapter} > ${value?.classRoom}`}
                    </p>

                    <Row>
                      <Col span={6}>
                        <div className="most-attempted-content__card-count attempt">
                          <img src={AttemptsIcon} /> {value?.attempts} attempts
                        </div>
                      </Col>
                      {/* {(value?.contentType == "video" ||
                        value?.contentType == "pdf") && (
                        <Col span={6}>
                          <div className="most-attempted-content__card-count pdf">
                            <img src={PdfIcon} /> {value?.contentLength}{" "}
                            {value?.contentType == "video" ? "mins" : "pages"}
                          </div>
                        </Col>
                      )} */}
              
                      <Col span={6}>
                        <div className="most-attempted-content__card-count like">
                          <img src={ThumbUpIcon} /> {value?.likes}
                        </div>
                      </Col>
                      <Col span={6}>
                        <div className="most-attempted-content__card-count dislike">
                          <img src={ThumbDownIcon} /> {value?.dislikes}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            );
          })
        )}
      </div>
    </div>
  );
};

export default MostAttemptedQuiz;
